module.exports = __webpack_public_path__ + "assets/ec4fc2b47b5005b17165d602f6532f94.mp3";